/**
 * Update Store - Web Stub
 * Browser handles updates automatically
 */

import { create } from 'zustand';

type UpdateState = {
  isUpdateAvailable: boolean;
  isUpdateModalOpen: boolean;
  updateInfo: null | {
    version: string;
    releaseNotes?: string;
  };
  isDownloading: boolean;
  downloadProgress: number;
  updateStatus: 'idle' | 'checking' | 'available' | 'downloading' | 'ready';
  updateError: string | null;
  installationType: 'appimage' | 'deb' | 'rpm' | null;

  // Actions
  checkForUpdates: () => Promise<void>;
  installUpdate: () => Promise<void>;
  setModalOpen: (open: boolean) => void;
};

export const useUpdateStore = create<UpdateState>(set => ({
  isUpdateAvailable: false,
  isUpdateModalOpen: false,
  updateInfo: null,
  isDownloading: false,
  downloadProgress: 0,
  updateStatus: 'idle',
  updateError: null,
  installationType: null,

  checkForUpdates: async () => {
    // No-op in web - browser handles updates
  },
  installUpdate: async () => {
    // No-op in web - browser handles updates
  },
  setModalOpen: (open: boolean) => {
    set({ isUpdateModalOpen: open });
  },
}));

// Atomic selectors
export const useUpdateStatus = () => useUpdateStore(state => state.updateStatus);
export const useUpdateInfo = () => useUpdateStore(state => state.updateInfo);
export const useUpdateProgress = () => useUpdateStore(state => state.downloadProgress);
export const useUpdateError = () => useUpdateStore(state => state.updateError);
export const useInstallationType = () => useUpdateStore(state => state.installationType);
export const useIsUpdateModalOpen = () => useUpdateStore(state => state.isUpdateModalOpen);
export const useSetModalOpen = () => useUpdateStore(state => state.setModalOpen);
